/**
 * A wrapper around an API function to handle different
 * states e.g. loading, error and response received.
 *
 * Serves as an extended version for ApiMixin that
 * accommodates more than one API call per-component.
 */
export default {
  data() {
    return {
      api: {},
    };
  },
  methods: {
    registerApis(apiNames) {
      apiNames.forEach((name) =>
        this.$set(this.api, name, {
          loading: false,
          error: null,
          response: null,
          hasError: false,
        })
      );
    },
    async request(apiName, apiFunction, ...params) {
      if (!this.api[apiName]) {
        this.registerApis([apiName]);
      }

      this.api[apiName].loading = true;
      this.api[apiName].error = null;

      try {
        const response = await apiFunction(...params);
        this.api[apiName].response = response;
        this.api[apiName].hasError = false;
        return response;
      } catch (err) {
        this.api[apiName].error = err;
        this.api[apiName].hasError = true;
      } finally {
        this.api[apiName].loading = false;
      }
    },
  },
};
